/* eslint-disable */
import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      marginBottom: 50,
    },
    header: {
      textAlign: "center",
      fontSize: "25px",
      fontWeight: "bold",
    },
    link: {
      textDecorationColor: "#004a96",
      color: "#004a96",
    },
    button: {
      marginTop: theme.spacing(2),
    },
  });
